import React, { useEffect, useState } from "react";
import EFTAuthDetails from "../../../Dialogs/EFTAuthDetails";
import { DialogComponent } from "../../../common/DialogComponent";
import * as service from "../../../../store/service";
import BillingInformationView from "./BillingInformationView";
import BillingInformationHeader from "./BillingInformationHeader";
import CancelInAppSubscription from "./CancelInAppSubscription";
import IDFBillingInformationForm from "./IDFBillingInformationForm";
import BillingInformationHeaderDescription from "./BillingInformationHeaderDescription";
import BillingInfomationHeaderAction from "./BillingInfomationHeaderAction";
import BillingInformationForm from "./BillingInformationForm";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../../store";
import InAppDetails from "./InAppDetails";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/ezs/actions";
import { ezsServiceIds, idfServiceIds } from "../../../../config/UserServicesList";
import { useAreServicesActive } from "../../../../util/CommonServices";
import { staticURLs } from "../../../../config/urls";
import * as MyAccountActions from "../../../../store/myAccount/actions";
import * as services from "../../../../store/service";
import BillingSecurityNote from "../../../Registration/Billing/BillingSecurityNote";
import { useTranslation } from "react-i18next";

const BillingInformation = (props: any) => {
    const dispatch = useDispatch();
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const GetIsIdfUser = () => dispatch(MyAccountActions.actionCreators.GetIsIdfUser());
    const isIDFFlagLoading = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUserLoading ? state.myAccountServiceState.isIdfUserLoading : false
    );
    const isIDFUser = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUser ? state.myAccountServiceState.isIdfUser : false
    );
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const [EFTdialog, setEFTDialog] = useState(false);
    const [billingInfo, setBillingInfo] = useState<any>();
    const [isLoading, setisLoading] = useState(false);
    const isBillingInfoChanged = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isBillingInfoChanged ? state.myAccountServiceState.isBillingInfoChanged : false
    );
    const SetIsBillingInfoChangedStatus = (status: boolean) => dispatch(MyAccountActions.actionCreators.SetIsBillingInfoChangedStatus(status));

    const [showForm, setShowForm] = useState(false);
    const [paymentDataLoading, setPaymentDataLoading] = useState(false);
    const [hasBillingInfo, setHasbillingInfo] = useState(false);
    const [contactInfo, setContactInfo] = useState({
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        phoneNumber: "",
    });
    const isMobileAttackControllActive = useAreServicesActive([idfServiceIds.mobileAttackControl, ezsServiceIds.mobileAttackControl]);

    const protectionPlanSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanState;
    });

    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };
    const { t: tLang } = useTranslation();

    useEffect(() => {
        setisLoading(true);

        services
            .getMonitoring()
            .then((getMonitoringResponse) => {
                setisLoading(false);

                const asset = getMonitoringResponse.asset ? getMonitoringResponse.asset : null;

                let userContactData = {
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    country: "",
                    zipCode: "",
                    phoneNumber: "",
                };
                if (asset && asset.addressInformation) {
                    const data = asset.addressInformation;
                    userContactData = {
                        ...userContactData,
                        address1: data["address-street"] ? data["address-street"] : "",
                        address2: data["address-street2"] ? data["address-street2"] : "",
                        city: data["address-city"] ? data["address-city"] : "",
                        state: data["address-state"] ? data["address-state"] : "",
                        country: data["address-country"] ? data["address-country"] : "",
                        zipCode: data["address-code"] ? data["address-code"] : "",
                    };
                }

                if (asset && asset.personalInformation && asset.personalInformation["primary-phone"]) {
                    const promaryPhone = asset.personalInformation["primary-phone"];
                    userContactData = {
                        ...userContactData,
                        phoneNumber: promaryPhone["phone"] ? promaryPhone["phone"] : "",
                    };
                }
                setContactInfo(userContactData);
            })
            .catch(function (error) {
                setisLoading(false);
            });
    }, []);

    const getHasBillingInformation = (billingInfo: any) => {
        if (billingInfo && billingInfo.creditCard && billingInfo.creditCard.cardNumber) {
            return true;
        }
        if (billingInfo && billingInfo.eft && billingInfo.eft.accountNumber) {
            return true;
        }
        return false;
    };

    const getPaymentDetail = () => {
        setPaymentDataLoading(true);
        GetIsIdfUser();
        service
            .GetPaymentDetail()
            .then((data) => {
                setPaymentDataLoading(false);
                setBillingInfo(data);
                setHasbillingInfo(getHasBillingInformation(data));
            })
            .catch(() => {
                setPaymentDataLoading(false);
            });
    };

    useEffect(() => {
        requestProtectionPlan(false);
        getPaymentDetail();
        SetIsBillingInfoChangedStatus(false);
    }, [isBillingInfoChanged === true]);

    const isLoadingBillingInformationData = () => {
        if (isLoading || paymentDataLoading || isIDFFlagLoading || protectionPlanSelector.isLoading) {
            return true;
        }
        return false;
    };

    const inAppDetails = billingInfo && billingInfo.inAppDetails;
    let showInAppDetails = false;
    let paymentTypeMessage = "";
    let appStoreURL = "";

    if (inAppDetails && inAppDetails.paymentType) {
        showInAppDetails = true;
        paymentTypeMessage = inAppDetails.paymentType === "Google" ? "Google Play" : "iOS App";
        if (isBusinessUser) {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.BusinessUserAndroidApp : staticURLs.BusinessUseriOSApp;
        } else if (isIDFUser) {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.IDFAndroidApp : staticURLs.IDFiOSAPP;
        } else {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.EzsAndroidApp : staticURLs.EzsiOSAPP;
        }
    }

    const showInappCancelation = () => {
        if (showInAppDetails && isMobileAttackControllActive && !hasBillingInfo) {
            return true;
        }
        return false;
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch {}
        }
    }, [showForm]);

    const renderBillingView = () => {
        if (showInappCancelation()) {
            return (
                <React.Fragment>
                    <CancelInAppSubscription appStoreURL={appStoreURL} paymentTypeMessage={paymentTypeMessage} />
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="box-header">
                        <BillingInformationHeader />
                        {showForm && (
                            <div className="box-description">
                                <BillingSecurityNote />
                            </div>
                        )}
                        {!hasBillingInfo && !showForm && <BillingInformationHeaderDescription message={tLang("manageAccount.myAccount.billing.noBillingInfo")} />}
                        {!showForm && (
                            <BillingInfomationHeaderAction
                                setShowForm={setShowForm}
                                buttonText={
                                    hasBillingInfo
                                        ? tLang("manageAccount.myAccount.billing.editButtonText1")
                                        : tLang("manageAccount.myAccount.billing.addButtonText1")
                                }
                            />
                        )}
                    </div>
                    <div className="box-content">
                        {!showForm && hasBillingInfo && <BillingInformationView billingInfo={billingInfo} />}
                        {!showForm && billingInfo && <InAppDetails isIDFUser={isIDFUser} billingInfo={billingInfo} />}
                        {showForm && !isIDFUser && (
                            <BillingInformationForm
                                setHasbillingInfo={setHasbillingInfo}
                                setBillingInfo={setBillingInfo}
                                contactInfo={contactInfo}
                                setEFTDialog={setEFTDialog}
                                billingInfo={billingInfo}
                                setShowForm={setShowForm}
                                IsIDFUser={false}
                            />
                        )}
                        {showForm && isIDFUser && (
                            <IDFBillingInformationForm
                                setHasbillingInfo={setHasbillingInfo}
                                setBillingInfo={setBillingInfo}
                                contactInfo={contactInfo}
                                setEFTDialog={setEFTDialog}
                                billingInfo={billingInfo}
                                setShowForm={setShowForm}
                                IsIDFUser={true}
                            />
                        )}
                    </div>
                </React.Fragment>
            );
        }
    };

    return (
        <React.Fragment>
            <div className={isLoadingBillingInformationData() ? "box offset-padding loading" : "box offset-padding"}>{billingInfo && renderBillingView()}</div>

            {EFTdialog && (
                <DialogComponent hideCloseButton={true} dialogId="etf-auth-details" title="ETF Authorization dialog" closeDialog={handleCloseEFTDialog}>
                    <EFTAuthDetails closeDialog={handleCloseEFTDialog} dialogId="etf-auth-details"></EFTAuthDetails>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default BillingInformation;
